import Button from '@rio-cloud/rio-uikit/Button';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { DialogType, useModal } from '@/hooks/useModal';

export const TerminationModal = () => {
    const [show, setShow] = useState(false);
    const { openDialog, closeDialog } = useModal();

    useEffect(() => {
        if (!show) {
            return;
        }

        openDialog({
            type: DialogType.SIMPLE,
            show,
            onClose: () => {
                setShow(false);
            },
            title: <FormattedMessage id='chargingContract.terminateContract.title' />,
            body: (
                <FormattedMessage
                    id='chargingContract.terminateContract.description'
                    values={{
                        b: content => <strong>{content}</strong>,
                    }}
                />
            ),
            showCloseButton: false,
            bsSize: 'sm',
            footer: (
                <Button
                    onClick={() => {
                        setShow(false);
                        closeDialog();
                    }}
                    className='btn btn-primary'
                >
                    <FormattedMessage id='general.button.goBack' />
                </Button>
            ),
        });
    }, [closeDialog, openDialog, show]);
    return (
        <div className='margin-top-25'>
            <div className='margin-top-15 display-flex width-100pct justify-content-end'>
                <Button onClick={() => setShow(true)} className='btn btn-danger'>
                    <FormattedMessage id='chargingContract.button.terminate' />
                </Button>
            </div>
        </div>
    );
};
